import './LegalReferenceNumber.scss';
import React from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {getDerivedLegalReferenceNumber} from 'state/legalReferenceNumbers/LegalReferenceNumberSelectors';

const LegalReferenceNumber = ({
  derivedLegalReferenceNumber,
  providedLegalNumber = '',
}) => {

    return (
  <div
      className="reference-number"
      id={`legal-reference-number-${providedLegalNumber || derivedLegalReferenceNumber}`}
    >
      <p>{providedLegalNumber || derivedLegalReferenceNumber}</p>
    </div>
    );
}
const mapStateToProps = (state) => ({
  derivedLegalReferenceNumber: getDerivedLegalReferenceNumber(state),
});

export default compose(connect(mapStateToProps))(LegalReferenceNumber);
